<template>
	<div class="con-list">
		<el-form ref="jobInfoForm" :model="jobInfoForm">
			<ul>
				<li>
					<div class="inline-filed">
						<el-form-item prop="deptId" v-if="!isDetail" label="部门：" :rules="[{required: true, message: '部门不能为空'}]">
							<el-select
								ref="deptInfo"
								v-model="jobInfoForm.deptId"
								:disabled="isDetail"
								:remote-method="getDeptInfo"
								filterable
								clearable
								remote
								@change="getLeaderInfo"
								placeholder="请输入部门名称搜索"
								:loading="loading"
								loading-text="请稍等..."
								@focus="deptinfoList=[]"
								@clear="deptinfoList=[]">
								<el-option
									v-for="item in deptinfoList"
									:key="`dept-${item.id}`"
									:label="item.name"
									:value="item.id">
									<span>{{item.id}}/{{ item.deptFullName }}</span>
								</el-option>
							</el-select>
							
						</el-form-item>
						<el-form-item label="部门：" v-else>
							<el-input disabled v-model="applyData.deptDescr"></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed">
						<el-form-item prop="supervisorId" v-if="!isDetail" label="直接上级：" :rules="[{
						required: true, message: '直接上级不能为空'}]">
							<el-select
								ref="superVisorInfo"
								v-model="jobInfoForm.supervisorId"
								:disabled="isDetail"
								:remote-method="getPersonInfo"
								filterable
								clearable
								remote
								:loading="loading"
								loading-text="请稍等..."
								placeholder="请输入上级名字搜索"
								@focus="personList=[]"
								@clear="personList=[]">
								<el-option
									v-for="item in personList"
									:key="item.empId"
									:label="item.name"
									:value="item.empId">
									<span>{{ item.name }}/{{item.deptName}}</span>
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="直接上级：" v-else>
							<el-input disabled v-model="applyData.supervisorName"  ></el-input>
						</el-form-item>
					</div>
				</li>
				<li>
					<div class="inline-filed">
						<el-form-item prop="jobCode" v-if="!isDetail" label="职务：" :rules="[{
						required: true, message: '职务不能为空'}]">
							<el-select
								ref="jobInfo"
								v-model="jobInfoForm.jobCode"
								:disabled="isDetail"
								:remote-method="getOutsideJob"
								filterable
								clearable
								remote
								@change="selectJob"
								:loading="loading"
								loading-text="请稍等..."
								placeholder="请输入职务名称搜索"
								@focus="jobTypeList=[]"
								@clear="jobTypeList=[]">
								<el-option
									v-for="item in jobTypeList"
									:key="item.jobcode"
									:label="item.name"
									:value="item.jobcode">
									<span>{{item.descr}}</span>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="jobCode" label="职务：" v-else>
							<el-input disabled v-model="applyData.jobDescr"></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed">
						<el-form-item prop="seqRank" v-if="!isDetail" label="职级：" :rules="[{
						required: true, message: '职级不能为空'}]">
							<el-input v-model="jobInfoForm.seqRank"  disabled ></el-input>
						</el-form-item>
						<el-form-item  label="职级：" v-else >
							<el-input v-model="applyData.seqRankDescr" disabled></el-input>
						</el-form-item>
					</div>
				</li>
				<li>
					<div class="inline-filed">
						<el-form-item prop="expEntryDate" v-if="!isDetail" :label="timeWord" :rules="[{
						required: true, message: '预计入职时间不能为空'}]">
							<el-date-picker
							v-model="jobInfoForm.expEntryDate"
							:disabled="isDetail"
							type="date"
							ref="dataCalc"
							@change="isGoDay"
							value-format="yyyy-MM-dd"
							:picker-options="pickerOptions1"
							placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item prop="expEntryDate" v-else :label="timeWord">
							<el-input v-model="applyData.expEntryDate" disabled></el-input>
						</el-form-item>
					</div>
					<div class="inline-filed">
						<el-form-item prop="location" label="工作地点：" v-if="!isDetail" :rules="[{
						required: true, message: '工作地点不能为空'}]">
							<el-select
								ref="addresInfo"
								v-model="jobInfoForm.location"
								:disabled="isDetail"
								:remote-method="getAddressList"
								filterable
								clearable
								remote
								:loading="loading"
								loading-text="请稍等..."
								placeholder="请输入地点关键字搜索"
								@change="locationChange"
								@focus="addressList=[]"
								@clear="addressList=[]">
								<el-option
									v-for="item in addressList"
									:key="item.code"
									:label="item.name"
									:value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item  label="工作地点：" v-else >
							<el-input disabled v-model="applyData.locationDescr" ></el-input>
						</el-form-item>
					</div>
				</li>
			</ul>
		</el-form>
	</div>
</template>


<script>
import moment from 'moment'
import {
	getOutsideJob, getAddress, getDeptList, getUsers, getSchedule,
	getSocialInfo,
} from '../network'

export default {
	name: 'jobInfo',
	props: {
		applyData: {},
		allCheck: {
			type:Boolean,
		},
		isMobile: {
			type:Boolean,
		},
		isDetail:{
			type: Boolean,
		},
		emplTypeTransCode: {
			type: String,
			default: '',
		},
		socailFlag: {
			type: String,
			default: '',
		},
		value: {}
	},
	data() {
		return {
			pickerOptions1: {
				disabledDate(time) {
					return Date.now()- 8.64e7 > time.getTime()
				}
			},
			timeWord:'预计入职时间：',
			jobInfoForm: {
				deptId: '', // 部门id
				supervisorId: '', // 直接上级
				seqRank:'', // 职级
				jobCode: '', // 职务
				expEntryDate: '', // 入职日期
				location: '', // 地点
			},
			personList:[],
			jobTypeList:[{
				jobcode: '', 
				descr: '',
				rank: '',
				rankCode: '', 
			}],
			addressList: [],
			disabledTime: [],
			deptinfoList:[],
			loading: false,
		};
	},
	created() {
		this.isMobile ? this.timeWord = '入职时间：' : this.timeWord="预计入职时间："
		if(this.$route.query && this.$route.query.bizId){
			this.jobInfoForm = Object.assign({},this.applyData)
		}
	},
	watch: {
		value: {
			handler() {
				const newObj = {}
				this.jobInfoForm = Object.assign(newObj, this.jobInfoForm, this.value)
				const { deptDescr, deptId, supervisorId, supervisorName, jobCode, jobDescr, location, locationDescr } = this.jobInfoForm
				// 部门deptinfoList
				this.deptinfoList = [{
					name: deptDescr,
					id: deptId,
					deptFullName: deptDescr,
				}]
				// 直接上级personList
				this.personList = [{
					empId: supervisorId,
					name: supervisorName,
					deptName: '',
				}]
				// 职务jobTypeList
				this.jobTypeList = [{
					jobcode: jobCode,
					name: jobDescr,
					descr: jobDescr,
				}]
				// 工作地点addressList
				this.addressList = [{
					code: location,
					name: locationDescr,
				}]
			},
			deep: true,
		},
	},
	methods: {
		resetJob(){
			this.jobInfoForm.jobCode = ''
			this.jobInfoForm.seqRank = ''
			this.jobTypeList = []
		},
		// 根据部门获取负责人
		getLeaderInfo(){
			this.deptinfoList.forEach((item)=>{
				if(this.jobInfoForm.deptId === item.id){
					this.personList = [{
						name: item.deptLeaderName,
						empId: item.deptLeaderId,
					}]
					this.jobInfoForm.supervisorId = item.deptLeaderId

				}
			})
		},
		saveJobData() {
			const { seqRank, deptId, supervisorId, jobCode, location, expEntryDate } = this.jobInfoForm
			this.$emit('changejobData', {
				seqRank,
				deptId,
				supervisorId,
				jobCode,
				location,
				expEntryDate
			})
		},
		validateJob() {
			this.saveJobData()
			this.$nextTick(() => {
				this.$refs.jobInfoForm.validate((valid) => {
					if (valid) {
						this.$emit('getJobCheck', true);
					} else {
						this.$emit('getJobCheck', false);
					}
				})
			})
		},
		// 获取工作地点列表
		getAddressList(query) {
			this.loading = true
			if (query !== '') {
				setTimeout(() => {
					this.addressList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						name: query,
					}
					return getAddress(params).then((res)=>{
						this.loading = false
						let data = res.data
						if(data.code === 'S00000'){
							this.addressList = data.data.list;
						} else {
							this.$message.error(data.message)
						}
					}).catch((error)=>{
						this.loading = false
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.addressList = []	
			}
		},
		// 判断是否工作日
		isGoDay(dateVal){
			if(dateVal && dateVal !== ''){
				return getSchedule(dateVal).then((res)=>{
					let data = res.data
					if(data.code === 'S00000'){
						if(data.data.status === 'Y'){
							this.$message.warning(dateVal+'是非工作日，请选择工作日')
							this.jobInfoForm.expEntryDate = ''
						}
					} else {
						this.$message.error(data.message)
					}
				}).catch((error)=>{
					// this.$message.error(JSON.stringify(error))
				})
			}
		},
		// 搜索部门
		getDeptInfo(query) {
			if (query !== '') {
				setTimeout(() => {
					this.deptinfoList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						queryName: query,
					}
					this.loading = true
					getDeptList(params).then((res)=>{
						this.loading = false;
						let data =res.data
						if(data.code === 'S00000'){
							this.deptinfoList = data.data.list;
							this.deptinfoList.forEach((item)=>{
								if (this.$isQf) {
									if(item.deptFullName.match(/千峰合泰\/(\S*)/).length > 0){
										item.deptFullName = item.deptFullName.match(/千峰合泰\/(\S*)/)[1]
									}
								} else {
									if(item.deptFullName.match(/车好多集团\/(\S*)/).length > 0){
										item.deptFullName = item.deptFullName.match(/车好多集团\/(\S*)/)[1]
									}
								}
							})
						} else {
							this.$message.error(data.message)
						}
					}).catch((error)=>{
						this.loading = false
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.deptinfoList = []	
			}
		},
		// 搜索职务带出职级
		selectJob(val) {
			this.jobTypeList.forEach((item)=>{
				if(item.jobcode === val){
					this.jobInfoForm.seqRank = item.rankCode
					return
				}
			})
			const { emplType } = this.applyData
			let flag = val && this.jobInfoForm.location
			if (this.socailFlag === 'Y') {
				this.getSocialInfo(flag)
			} else if (['11', '37'].includes(emplType)) {
				this.getSalary(flag)
			}
			this.emitEvent({code:'jobCode',val:val})
		},
		emitEvent(data){
			this.$emit('select',data)
		},
		locationChange(val) { // 工作地点变更
			this.emitEvent({code:'workLocation',val:val})
			const { emplType } = this.applyData
			let flag = val && this.jobInfoForm.jobCode
			if (this.socailFlag === 'Y') {
				this.getSocialInfo(flag)
			} else if (['11', '37'].includes(emplType)) {
				this.getSalary(flag)
			}
		},
		//查人
		getPersonInfo(query){
			this.loading = true
			if (query !== '') {
				setTimeout(() => {
					this.personList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						queryName: query,
					}
					return getUsers(params).then((res)=>{
						this.loading = false
						let data =res.data
						if(data.code === 'S00000'){
							this.personList = data.data;
						} else {
							this.$message.error(data.message)
						}
					}).catch((error)=>{
						this.loading = false
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.personList = []	
			}
		},
		// 查询职务
		getOutsideJob(query){
			if(this.applyData && this.applyData.emplType === ''){
				this.$message.warning("请选择员工类型")
				return
			}
			this.loading = true
			if (query !== '') {
				setTimeout(() => {
					this.jobTypeList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						name: query,
						emplType: this.applyData.emplType,
					}
					return getOutsideJob(params).then((res)=>{
						this.loading = false
						let data =res.data
						if(data.code === 'S00000'){
							this.jobTypeList = data.data.list;
						} else {
							this.$message.error(data.message)
						}
					}).catch((error)=>{
						this.loading = false
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.jobTypeList = []	
			}
			
		},
		// 查询基本工资
		async getSalary(flag) {
			if (flag) {
				let { jobCode, location, emplType } = this.jobInfoForm
				let res = await getSocialInfo({
					jobCode,
					workLocation: location,
					emplType: this.emplTypeTransCode,
				}).catch()
				if (!res) return
				let { baseSalary, performSalary, yearBonusMonth } = res.data.data
				let changeInfo = {}
				if (['11', '37'].includes(emplType)) {
					changeInfo.basePay = baseSalary || ''
					changeInfo.perfomPay = performSalary || ''
					changeInfo.yearBonusNum = typeof yearBonusMonth === 'number' ? yearBonusMonth.toString() : ''
					changeInfo.optionNum = 0
				}
				this.$emit('changejobData', changeInfo)
			}
		},
		// 根据职务信息查询社保
		async getSocialInfo(flag) {
			if (flag) {
				this.$emit('changeData')
				let { jobCode, location, seqRank, deptId, supervisorId, expEntryDate, } = this.jobInfoForm
				let res = await getSocialInfo({
					jobCode,
					workLocation: location,
					emplType: this.emplTypeTransCode,
				}).catch()
				if (!res) return
				let { 
					socialInsuranceLocation, socialInsuranceLocationDescr,
					beRegularEmpPay, socialInsuranceBase,
					accidentInsurance, accidentInsuranceMedicine,
					houseAccFundBase, houseAccFundBaseMax,
					curDownLimit, baseSalary, performSalary, yearBonusMonth,
				} = res.data.data
				let accFoundMax = houseAccFundBaseMax
				houseAccFundBaseMax = this.socialBase(res.data.data)
				let changeInfo = {
					socialInsuranceLocation, socialInsuranceLocationDescr,
					beRegularEmpPay, socialInsuranceBase,
					accidentInsurance, accidentInsuranceMedicine,
					houseAccFundBase, houseAccFundBaseMax,
					accFoundMax, curDownLimit,
					seqRank, deptId, supervisorId, jobCode, location, expEntryDate,
				}
				if (['11', '37'].includes(this.applyData.emplType)) {
					changeInfo.basePay = baseSalary || ''
					changeInfo.perfomPay = performSalary || ''
					changeInfo.yearBonusNum = typeof yearBonusMonth === 'number' ? yearBonusMonth.toString() : ''
					changeInfo.optionNum = 0
				}
				this.$emit('changejobData', changeInfo)
			} else {
				this.$emit('changejobData', {
					socialInsuranceLocation: '',
					socialInsuranceLocationDescr: '',
					beRegularEmpPay: '',
					socialInsuranceBase: '',
					accidentInsurance: '',
					accidentInsuranceMedicine: '',
					houseAccFundBase: '',
					houseAccFundBaseMax: '',
					accFoundMax: 0,
					curDownLimit: 0,
				})
			}
		},
		socialBase(data) {
            let { basePay, perfomPay } = this.applyData
            let { houseAccFundBaseMax, houseAccFundBase, curDownLimit } = data
			let result
			let sum = Number(basePay) + Number(perfomPay)
			if (isNaN(sum)) {
				sum = '0.00'
			} else {
				sum = (Math.round(sum * 100) / 100).toFixed(2)
			}
            if (houseAccFundBase === 'SAL' && houseAccFundBaseMax > sum) {
				result = sum
            } else if (houseAccFundBase === 'SAL') {
                result = houseAccFundBaseMax
            } else {
				result = curDownLimit
			}
            return result
        },
	},
}
</script>
